// keywordAutocomplete/quicklistSource.js — wraps the legacy `quicklist` AJAX (basic.js dynAutocomplete) as an
// injectable suggestion source for the contenteditable autocomplete: search(term) → Promise<[{ label, hidden }]>.
//
// Same request/response as before: POST action=quicklist { search, published, type }, CSRF header (meta tag);
// response { success, keywords: "a,b,c", hiddenkeywords: "a,b" } → keyword list flagged with hidden-ness. The
// field context (published / category) is injected by the consumer so the source stays reusable across fields.

const AJAX_URL = "/includes/ajax.php";

function csrfToken() {
    const m = document.querySelector('meta[name="csrf-token"]');
    return (m && m.getAttribute("content")) || "";
}

// Pure: quicklist response → [{ label, hidden }]. hidden = keyword is in the hiddenkeywords list. Unit-testable.
export function quicklistItemsFromResponse(data) {
    if (!data || !data.success || !data.keywords) { return []; }
    const keywords = String(data.keywords).split(",");
    const hidden = new Set(data.hiddenkeywords ? String(data.hiddenkeywords).split(",") : []);
    return keywords.map((k) => ({ label: k, hidden: hidden.has(k) }));
}

// Self-contained source. `published`/`category`/`vp` come from the field's context (documents.js supplies them).
export function createQuicklistSource({ published = false, category = null, vp } = {}) {
    return async function search(term) {
        const body = new URLSearchParams({ action: "quicklist", search: term, published: String(published) });
        if (category != null) { body.set("type", category); }
        if (vp !== undefined) { body.set("vp", String(vp)); }
        try {
            const res = await fetch(AJAX_URL, {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/x-www-form-urlencoded", Csrftoken: csrfToken() },
                body: body.toString(),
            });
            if (!res.ok) { return []; }
            return quicklistItemsFromResponse(await res.json());
        } catch (e) {
            return [];
        }
    };
}
